import { render } from "./Footer.vue?vue&type=template&id=ac00be6c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=ac00be6c&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Desktop/SILA/Web/phone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac00be6c"]])

export default __exports__